var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ComponentIds, } from "@inter-ikea-core/core";
import { FunctionalZoneValidationBase } from "./FunctionalZoneValidationBase";
import { ZoneVsZoneValidationResult } from "./ZoneVsZoneValidationResult";
/**
 * A validation that can react on intersections between functional zones.
 *
 * An example could be a toaster that has an electrical zone and a shower that has a water zone. Then you could
 * add this to generate validation errors whenever the electrical zone and the water zone intersect, preventing
 * the toaster to be placed in the shower.
 */
var ZoneVsZoneRule = /** @class */ (function (_super) {
    __extends(ZoneVsZoneRule, _super);
    function ZoneVsZoneRule(restrictedLayer1, restrictedLayer2, severity, includeAncestors) {
        var _this = _super.call(this) || this;
        _this.restrictedLayer1 = restrictedLayer1;
        _this.restrictedLayer2 = restrictedLayer2;
        _this.severity = severity;
        _this.includeAncestors = includeAncestors;
        _this.id = "ZoneVsZoneRule layers:".concat(restrictedLayer1, " vs ").concat(restrictedLayer2);
        return _this;
    }
    ZoneVsZoneRule.prototype.checkIntersectingZones = function (entity, other) {
        var _this = this;
        var result = null;
        if (other.hasComponent(ComponentIds.FUNCTIONAL_ZONES_WORLD_COMPONENT_ID) &&
            entity.hasComponent(ComponentIds.FUNCTIONAL_ZONES_WORLD_COMPONENT_ID)) {
            var myZones = entity.getComponentUnsafe(ComponentIds.FUNCTIONAL_ZONES_WORLD_COMPONENT_ID).zones;
            var otherZones_1 = other.getComponentUnsafe(ComponentIds.FUNCTIONAL_ZONES_WORLD_COMPONENT_ID).zones;
            myZones.forEach(function (myZone) {
                return otherZones_1.forEach(function (otherZone) {
                    var bothZonesIncludedInRestrictedLayers = _this.restrictedLayer1 === myZone.layer &&
                        _this.restrictedLayer2 === otherZone.layer;
                    if (bothZonesIncludedInRestrictedLayers &&
                        myZone.polyhedron.penetration(otherZone.polyhedron)) {
                        result = new ZoneVsZoneValidationResult(_this.severity, _this, other, otherZone, entity, myZone);
                        return;
                    }
                });
            });
        }
        return result;
    };
    /**
     * Checks zone vs zone intersection of the hierarchy of the entity against another specified entity.
     * In case the other entity is part of the own hierarchy then it is excluded from testing.
     * In case the other entity is an ancestor then the property includeAncestors of the rule determines
     * if it should be included in testing or not.
     */
    ZoneVsZoneRule.prototype.checkZoneIntersectionOfOwnHierarchy = function (snapRootHierarchy, entity, other, parentOfEntityToValidate) {
        if (snapRootHierarchy.some(function (e) { return e.id === other.id; }))
            // Don't check against entities in our own hierarchy
            return null;
        // Either generate warnings even for ancestor or make sure it isn't an ancestor
        if (!this.includeAncestors &&
            this.potentialParentIsAncestor(other, parentOfEntityToValidate))
            return null;
        var result = this.checkIntersectingZones(entity, other);
        if (result)
            return result;
        // In case the layers we test are not the same then we need to test it the other way around as well (if they were the same then we already tested this...)
        if (this.restrictedLayer1 !== this.restrictedLayer2) {
            var resultOtherWay = this.checkIntersectingZones(other, entity);
            if (resultOtherWay)
                return resultOtherWay;
        }
        return null;
    };
    return ZoneVsZoneRule;
}(FunctionalZoneValidationBase));
export { ZoneVsZoneRule };
//# sourceMappingURL=ZoneVsZoneRule.js.map